<div class="container">
  <div class="card notification-card">
    <div class="card-body">
      <div class="row">
        <!-- Left section: Notification details -->
        <div class="col-md-6 d-flex flex-column justify-content-between left-section">
          <div>
            <div class="mt-3 ml-2">
              <h3 class="notify-title"> <img src="/assets/images/bell.png"
                  style="width:17px; margin-right:3px;margin-bottom: 3px;" alt=""> New Lead Incoming <img
                  src="/assets/images/bike_1.gif" style="width:50px; margin-left:7px;margin-bottom: 5px;" alt="">
              </h3>
            </div>
            <div class="mt-3 ml-2">
              <h5 class="card-title"> <img src="/assets/images/hand.png" style="margin-right: 3px;margin-bottom: 3px;"
                  alt=""> Hi {{username}}!</h5>
              <p class="card-text">
                Hope you are having a great day.
                <span> Here are a few updates that seek your immediate attention.
                  Kindly look into it at the earliest. </span>
              </p>
              <p class="description mt-2"> We have an exciting update for you – a new lead has just come in! </p>
              <ng-container>
                <ng-container>
                  <div class="booking-opportunity mt-2">
                    <span class="notification-heading"> Lead ID : {{newLeadData.lead_id}}</span>
                  </div>
                  <div class="booking-opportunity mt-1">
                    <span class="notification-heading"> Mobile : {{newLeadData.mobile}}</span>
                  </div>
                  <!-- <p class="text-muted">Today at {{notificationObject?.date | date: 'hh:mm a'}}</p> -->
                  <div class="d-grid gap-2 check-section mr-3 ml-2">
                    <button class="btn btn-sm btn-primary" type="button" (click)="navigateToDetails()">Click to
                      view</button>
                  </div>

                </ng-container>
              </ng-container>

            </div>
          </div>
        </div>
        <!-- Right section: Image -->
        <div class="col-md-6 d-flex align-items-center justify-content-center right-section">
          <img src="/assets/images/call-vector.png" alt="Notification Image" class="img-fluid">
          <img class="close-button close-mark" src="/assets/images/close.png" alt="" (click)="onClose()">
          <img class=" call-alert" src="/assets/images/call_alert.gif" alt="">
        </div>
      </div>
    </div>
  </div>
</div>